import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  error: null,
  data: {
    auditLog: [],
    selections: {},
    view: {}
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_SELECTIONS:
      return { ...state, error: null, isLoading: true };
    case Constants.RECEIVE_SELECTIONS:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          subscriber: action.subscriber,
          selections: { ...action.data?.selections }
        }
      };
    case Constants.VIEW_SELECTION:
      return {
        ...state,
        data: {
          ...state.data,
          view: {
            subscriber: action.subscriber,
            jobId: action.jobId,
            blockId: action.blockId
          }
        }
      };
    case Constants.REQUEST_PROFILE_AUDIT:
      return { ...state, error: null, isLoading: true };
    case Constants.RECEIVE_PROFILE_AUDIT:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          auditLog: [...(action.data?.audit_log || [])]
        }
      };
    case Constants.REQUEST_EDIT_PROFILE_STATUS:
      return { ...state, error: null, isLoading: true };
    case Constants.RECEIVE_EDIT_PROFILE_STATUS:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          subscriber: action.subscriber,
          selections: {
            jobs: [...(state.data.selections.jobs || [])],
            profile: { ...action.data }
          }
        }
      };
    default:
      return state;
  }
}
